import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import * as api from './api'

export const getList = createAsyncThunk('customsDeclarations/GET_LIST', async (request, thunkAPI) => {
  const { data, error } = await api.getList({ ...request })
  if (error) return thunkAPI.rejectWithValue(error)
  return data
})

export const getDetail = createAsyncThunk(
  'customsDeclarations/GET_DETAIL',
  async ({ sefCustomsDeclarationId, version }, thunkAPI) => {
    const { data, error } = await api.getDetail(sefCustomsDeclarationId, version)
    if (error) return thunkAPI.rejectWithValue(error)
    return data
  },
)

export const getItemDetail = createAsyncThunk(
  'customsDeclarations/GET_ITEM_DETAIL',
  async ({ sefCustomsDeclarationId, version, itemOrdinalNumber }, thunkAPI) => {
    const { data, error } = await api.getItemDetail(sefCustomsDeclarationId, version, itemOrdinalNumber)
    if (error) return thunkAPI.rejectWithValue(error)
    return data
  },
)

export const slice = createSlice({
  name: 'customsDeclarations',
  initialState: {
    list: [],
    isListLoading: false,
    error: null,
    totalSize: 0,
    model: null,
    isModelLoading: false,
    modelError: null,
    itemDetail: null,
    isItemDetailLoading: false,
    itemDetailError: null,
  },
  reducers: {
    clearModel: state => {
      state.model = null
      state.modelError = null
    },
    clearItemDetail: state => {
      state.itemDetail = null
      state.itemDetailError = null
    },
  },
  extraReducers: builder => {
    builder
      .addCase(getList.pending, state => {
        state.isListLoading = true
        state.error = null
      })
      .addCase(getList.fulfilled, (state, action) => {
        state.isListLoading = false
        state.list = action.payload.data
        state.totalSize = action.payload.totalCount
      })
      .addCase(getList.rejected, (state, action) => {
        state.isListLoading = false
        state.error = action.payload
      })
      .addCase(getDetail.pending, state => {
        state.isModelLoading = true
        state.modelError = null
      })
      .addCase(getDetail.fulfilled, (state, action) => {
        state.isModelLoading = false
        state.model = action.payload
      })
      .addCase(getDetail.rejected, (state, action) => {
        state.isModelLoading = false
        state.modelError = action.payload
      })
      .addCase(getItemDetail.pending, state => {
        state.isItemDetailLoading = true
        state.itemDetailError = null
      })
      .addCase(getItemDetail.fulfilled, (state, action) => {
        state.isItemDetailLoading = false
        state.itemDetail = action.payload
      })
      .addCase(getItemDetail.rejected, (state, action) => {
        state.isItemDetailLoading = false
        state.itemDetailError = action.payload
      })
  },
})

export const { clearModel, clearItemDetail } = slice.actions

export const listSelector = state => state.customsDeclarations.list
export const errorSelector = state => state.customsDeclarations.error
export const isListLoadingSelector = state => state.customsDeclarations.isListLoading
export const totalSizeSelector = state => state.customsDeclarations.totalSize
export const modelSelector = state => state.customsDeclarations.model
export const isModelLoadingSelector = state => state.customsDeclarations.isModelLoading
export const modelErrorSelector = state => state.customsDeclarations.modelError
export const itemDetailSelector = state => state.customsDeclarations.itemDetail
export const isItemDetailLoadingSelector = state => state.customsDeclarations.isItemDetailLoading
export const itemDetailErrorSelector = state => state.customsDeclarations.itemDetailError
export const reducer = slice.reducer
